<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="green">
        <h4 slot="title" class="title">Logowanie</h4>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email" />
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Hasło...</label>
          <md-input type="password" v-model="password" />
        </md-field>
        <router-link slot="inputs" :to="{ path: '/reset' }"
          >Zapomniałeś/aś hasło?</router-link
        >
        <md-button
          @click="submit()"
          slot="footer"
          class="md-simple md-success md-lg"
        >
          Zaczynamy
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from '@/components'
export default {
  components: {
    LoginCard,
  },
  data() {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    submit() {
      this.$store
        .dispatch('login', {
          email: this.email.trim(),
          password: this.password.trim(),
        })
        .then(() => {
          this.$router.push('/orders')
          this.$message('Pomyślnie zalogowany')
        })
    },
  },
}
</script>

<style></style>
